import React from 'react';

interface StructuredDataProps {
  type: 'Organization' | 'WebSite' | 'Service' | 'LocalBusiness';
  data: any;
}

const StructuredData: React.FC<StructuredDataProps> = ({ type, data }) => {
  const getStructuredData = () => {
    switch (type) {
      case 'Organization':
        return {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Curiye.so",
          "alternateName": "Curiye Advertising Agency",
          "url": "https://curiye.so",
          "logo": "https://curiye.so/images/curiye-logo.svg",
          "description": "Creative agency specializing in visual storytelling, brand identity, and event branding. We craft brands that connect, inspire, and lead.",
          "foundingDate": "2020",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Mogadishu",
            "addressCountry": "Somalia"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+252-61-871-5418",
            "contactType": "customer service",
            "email": "info@curiye.com"
          },
          "sameAs": [
            "https://www.facebook.com/curiye.so",
            "https://www.instagram.com/curiye.so",
            "https://wa.me/252618715418"
          ],
          "serviceArea": {
            "@type": "Country",
            "name": "Somalia"
          },
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Creative Services",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Logo Design & Visual Identity",
                  "description": "Custom logo design and brand identity services"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Social Media Marketing",
                  "description": "Social media strategy and content creation"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Video Production",
                  "description": "Professional video production and editing services"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Event Branding",
                  "description": "Event identity design and branding solutions"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Web Design & Development",
                  "description": "Responsive web design and development services"
                }
              }
            ]
          }
        };

      case 'WebSite':
        return {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Curiye.so",
          "url": "https://curiye.so",
          "description": "Creative agency specializing in visual storytelling, brand identity, and event branding",
          "publisher": {
            "@type": "Organization",
            "name": "Curiye.so"
          },
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://curiye.so/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        };

      case 'LocalBusiness':
        return {
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Curiye.so",
          "image": "https://curiye.so/images/curiye-logo.svg",
          "description": "Creative agency specializing in visual storytelling, brand identity, and event branding",
          "url": "https://curiye.so",
          "telephone": "+252-61-871-5418",
          "email": "info@curiye.com",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Mogadishu",
            "addressCountry": "Somalia"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "2.0469",
            "longitude": "45.3182"
          },
          "openingHours": "Mo-Fr 09:00-18:00",
          "priceRange": "$$",
          "serviceArea": {
            "@type": "Country",
            "name": "Somalia"
          }
        };

      default:
        return data;
    }
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(getStructuredData(), null, 2)
      }}
    />
  );
};

export default StructuredData;
